import { useQuery } from '@tanstack/react-query';
import { useOrgId } from '@/common/hooks/useOrgId';
import { financeQueryKeys } from '@/common/queryKeys/finance';
import { OrganizationCurrencyApi } from '@/features/settings/organization-currency/api';

export const getOrganizationCurrencyQueryOptions = (organizationId: string) => ({
  queryKey: financeQueryKeys.organizationCurrency.all(organizationId),
  queryFn: () => OrganizationCurrencyApi.getOrganizationCurrency(),
  // Only changes via useSetOrganizationCurrencyMutation, which invalidates this
  // key on save — safe to treat as never stale otherwise.
  staleTime: Number.POSITIVE_INFINITY,
});

export const useOrganizationCurrencyQuery = () => {
  const orgId = useOrgId();
  return useQuery(getOrganizationCurrencyQueryOptions(orgId));
};
